const isSafari = !!navigator.userAgent.match(/Version\/[\d. ]+.*Safari/);
const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isEdge = window.navigator.userAgent.includes("Edge");
// Internet Explorer 6-11
var isIE = /*@cc_on!@*/ false || !!document.documentMode;

export const browser = {
    isSafari,
    isiOS,
    isIE,
    isEdge,
    webpSupported: !isSafari && !isiOS && !isIE,
};
